import Blue from "~/core";

new Blue({
    name: "survey modal",
    selector: ".survey",
    setup(survey) {
        const closeBtn = survey.querySelector(".js-survey-close");
        const accept = survey.querySelector(".js-survey-accept");
        const reject = survey.querySelector(".js-survey-reject")
        const surveyName = `acceptedSurvey--${survey.dataset.id}`
        const cookieArr = decodeURIComponent(document.cookie).split(";");

        if (!getCookie(surveyName)) {
            setTimeout(() => {
                if (!this.$screen.md.matches) {
                    createScrim()
                }
                
                survey.classList.add("survey--active");
                closeBtn.setAttribute("tabindex", 0);
                accept.setAttribute("tabindex", 0);
                reject.setAttribute("tabindex", 0);
            }, 1200);
        }

        const acceptCookies = () => {
            survey.classList.remove("survey--active");
            setCookie(surveyName, true, 365);
            destroyScrim()
        }
        const rejectCookies = () => {
            survey.classList.remove("survey--active");
            destroyScrim()
            setCookie(surveyName, false, 365);
        }

        this.$addEvents(closeBtn, "click enter", rejectCookies);
        this.$addEvents(reject, "click enter", rejectCookies);
        this.$addEvents(accept, "click enter", acceptCookies);

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
        function createScrim () {
            let scrimTest = document.getElementById('js-scrim')
            if(!scrimTest) {
                let scrim = document.createElement('div')
                scrim.classList.add('survey__scrim')
                scrim.id = 'js-scrim'
                document.body.appendChild(scrim)
                document.body.classList.add('scrim-is-open')
                listenScrim()
            }
          }
        function destroyScrim () {
            let scrim = document.getElementById('js-scrim')
            if(scrim){
                scrim.parentNode.removeChild(scrim)
                document.body.classList.remove('scrim-is-open')
            }
        }
        function listenScrim () {
            let scrim = document.getElementById('js-scrim')
            if(scrim){
                scrim.addEventListener('click', function () { 
                    survey.classList.remove("survey--active");
                    closeBtn.setAttribute("tabindex", -1);
                    accept.setAttribute("tabindex", -1);
                    reject.setAttribute("tabindex", -1);
                    destroyScrim()
                })
            }
          }
    }
});